import React from "react";
import './App.css';
import LayoutPage from "./layout/layout";
import 'antd/dist/antd.less';
import 'antd-button-color/dist/css/style.css';
import LoginForm from './login';
import UserProfile from './UserProfile';


import Cookies from 'universal-cookie';
const cookies = new Cookies();

const AuthenticationContext = React.createContext();
const { Provider, Consumer } = AuthenticationContext;
function Login(props) {
  return (
    <Consumer>
      {
        value =>
          <button onClick={value.login}>Login</button>
      }
    </Consumer>
  );
}

function Logout() {
  return (
    <>
      {
        value =>
          <button onClick={value.logout}>Logout</button>
      }
    </>
  );
}

function AnotherComponent() {
  return (
    <>
      {
        value => {
          return value.isAuthenticated ?
            <p>Logged in</p> :
            <p>Not Logged in</p>
        }
      }
    </>
  )
}
class App extends React.Component {
  constructor(props) {
    super(props);
    this.login = () => {
      this.setState({
        isAuthenticated: true
      });
    }
    this.logout = () => {
      // console.log("logoutlogoutlogout")
      localStorage.clear()
      this.setState({
        isAuthenticated: false
      });
    }
    this.state = {
      isAuthenticated: false,
      login: this.login,
      logout: this.logout,
      userData: {}
    };
  }

  componentDidMount = () => {

  }
  render() {
    let isAuthenticated = this.state.isAuthenticated
    if (UserProfile.getUserdata()) {
      // console.log('UserProfile.getUserdata', UserProfile.getUserdata().token)
      var userData = {
        imgUrl: '../storage/imgs/dfusers.png',
        firstName: UserProfile.getUserdata().firstName,
        lastName: UserProfile.getUserdata().lastName,
        level: UserProfile.getUserdata().level,
        levelDesc: UserProfile.getUserdata().levelDesc
      }
      isAuthenticated = true
    } else {
      isAuthenticated = false
    }
    return (
      <div className="App">
        {isAuthenticated == true ?
          < LayoutPage userData={userData} logout={this.state.logout} />
          :
          <LoginForm login={this.state.login} />
        }
      </div>
    );



  }
}

export default App;
